import { computed, unref, ref, watch } from 'vue'
import { ColumnProps } from 'ant-design-vue/es/table/interface'

export function setAllSelect(dataSource: any, key: string = 'id', all: boolean = false) {
    // 选择此页数据/全选数据
    const isSelectAll = ref(false)
    type Key = ColumnProps['key']
    const selectedRowKeys = ref<Key[]>([])
    const selectedObjs = ref<Object[]>([])
    const data = ref(dataSource)
    const rowSelection = computed(() => {
        return {
            selectedRowKeys: unref(selectedRowKeys),
            selectedObjs: unref(selectedObjs),
            onChange: onSelectChange,
            getCheckboxProps: checkboxDisabled,
            hideDefaultSelections: true,
            selections: [
                {
                    key: 'cur-data',
                    text: '当前页',
                    onSelect: (changableRowKeys: Key[]) => {
                        isSelectAll.value = false
                        selectedRowKeys.value = changableRowKeys
                        selectedObjs.value = data.value
                    }
                },
                all && {
                    key: 'all-data',
                    text: '全部',
                    onSelect: (changableRowKeys: Key[]) => {
                        isSelectAll.value = true
                        selectedRowKeys.value = changableRowKeys
                        selectedObjs.value = data.value
                    }
                }
            ]
        }
    })
    const onSelectChange = (changableRowKeys: Key[], selectedRows: Object[]) => {
        // 当前页，上一次选中的
        const lastSelectedList: Array<any> = getLastSelectedRow(data.value, selectedObjs.value)
        if (lastSelectedList.length < selectedRows.length) {
            // 增加
            selectedObjs.value = addSingleRow(selectedRows, selectedObjs.value)
        }
        else {
            /*
             * 删除
             * 本次删除的
             */
            const delRows: Array<any> = getDiffRow(lastSelectedList, selectedRows)
            selectedObjs.value = delSelectedRow(delRows, selectedObjs.value)
        }

        isSelectAll.value = false
        selectedRowKeys.value = changableRowKeys
    }

    // 找出上一次勾选的本页数组
    const getLastSelectedRow = (arr: Array<any>, list: Array<any>) => {
        /*
         * arr 当前页的数据 data
         * list 所有选择的数据 selectedObj
         */
        const newList: Array<any> = []
        const listIds: Array<string> = list.map((item: any) => {
            return item[key]
        })
        arr.forEach((item: any) => {
            if (listIds.indexOf(item[key]) > -1) {
                newList.push(item)
            }
        })
        return newList
    }

    // 找出此次删除的数组
    const getDiffRow = (arr: Array<any>, list: Array<any>) => {
        /*
         * arr 上一次选中的
         * list 本次选中的
         */
        const newList: Array<any> = []
        const listIds: Array<string> = list.map((item: any) => {
            return item[key]
        })
        arr.forEach((item: any) => {
            if (listIds.indexOf(item[key]) === -1) {
                newList.push(item)
            }
        })
        return newList
    }

    // 将新增的，去重后添加进去
    const addSingleRow = (arr: Array<any>, list: Array<any>) => {
        /*
         * arr 当前新增的数据
         * list 所有选择的数据
         */
        const newList: Array<any> = list
        const listIds: Array<string> = list.map((item: any) => {
            return item[key]
        })
        arr.forEach((item: any) => {
            console.log('将新增的，去重后添加进去')
            if (listIds.indexOf(item[key]) === -1) {
                newList.push(item)
            }
        })
        return newList
    }

    // 删除部分数组
    const delSelectedRow = (arr: Array<any>, list: Array<any>) => {
        /*
         * arr 当前要删除的
         * list 所有选择的数据
         */
        let newList: Array<any> = []
        const arrIds: Array<string> = arr.map((item: any) => {
            return item[key]
        })
        newList = list.filter((item: any) => arrIds.indexOf(item[key]) === -1)
        return newList
    }

    const refreshSelectedRowKeys = (newVal: any, oldVal: any) => {
        if (isSelectAll.value) {
            // 如果是全选状态
            selectedRowKeys.value = newVal.map((item: any) => {
                return item[key]
            })
            selectedObjs.value = newVal
        }
    }
    watch(data, refreshSelectedRowKeys)

    const checkboxDisabled = (record: any) => ({
        disabled:
            (record.waitAllocateCustomerCount === 0 && record.waitAllocateRoomCount === 0)
            || (record.disabled ? true : false)
    })

    return {
        isSelectAll,
        selectedRowKeys,
        selectedObjs,
        rowSelection
    }
}
